const PROTECTIONS = {
    EXTENDED_WARRANTY: 1,
    INSURANCE: 2,
    COSMETIC_PROTECTION: 3,
    PROTECTION: 6,
};

export { PROTECTIONS };
export default { PROTECTIONS };



// WEBPACK FOOTER //
// ./src/constants/protections.js